import { CallingTheme } from "@azure/communication-react";
import {
	PartialTheme,
	Theme,
	teamsDarkTheme,
	teamsHighContrastTheme,
	teamsLightTheme,
} from "@fluentui/react-components";
import { chatTeamsDarkTheme } from "./chat/chatTeamsDarkTheme";
import { chatTeamsLightTheme } from "./chat/chatTeamsLightTheme";
import { TeamsThemeType } from "./teamsThemeType";

export function mapTeamsTheme(themeName: string): Theme {
	const defaultTheme = teamsLightTheme;
	const themeMap = {
		[TeamsThemeType.Dark]: teamsDarkTheme,
		[TeamsThemeType.Contrast]: teamsHighContrastTheme,
		[TeamsThemeType.Default]: defaultTheme,
	};

	return themeMap[themeName as TeamsThemeType] || defaultTheme;
}

export function mapAzureCommunicationTheme(
	themeName: string
): PartialTheme & CallingTheme {
	const defaultTheme = chatTeamsLightTheme;
	const themeMap = {
		[TeamsThemeType.Dark]: chatTeamsDarkTheme,
		[TeamsThemeType.Contrast]: chatTeamsDarkTheme,
		[TeamsThemeType.Default]: defaultTheme,
	};

	return themeMap[themeName as TeamsThemeType] || defaultTheme;
}
